
<div class="reviewholder">
  <div class="logo">
    <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
  </div>
  <div class="info">
    <h2>Please review and act on these documents.</h2>
    <p>By Clicking on this link you agree to use electronic records and signatures.</p>    
    <button mat-flat-button color="primary"  (click)="IscreateProject(signature,userDetailCollect)">Accept</button>    
</div>
</div>


<ng-template #signature>  
  <h2 mat-dialog-title>
    <span  class="groupIcon" ><mat-icon>group_add</mat-icon></span>
    Add Relation & Assign Participants
       <button mat-icon-button (click)="close()">
         <mat-icon>close</mat-icon>
       </button>
 </h2>

  <mat-dialog-content class="mat-typography">
    <div class="signaturePanel">
      <div class="esign">
        <div class="panel" *ngIf="participantMessageInfo!=null">
          <div class="example-list">
        </div>
        <div class="groupHolder">
          <div cdkDropList class="example-list">
            <div class="groupheading" (click)="getToogleInformation()">
              <h2>
                <mat-icon>message</mat-icon>Information
              </h2>
              <button mat-icon-button> <mat-icon>expand_more</mat-icon> </button>
            </div>
           
              <div id="participantMessageDiv" [ngClass]="{'active' : toogleInformation}" innerHtml="{{participantMessageInfo}}"></div>
            
          </div>
        </div>
      </div>
        <div class="panel">
          
          <div class="groupHolder" *ngFor="let p1 of projectGroups">

            <div  id="{{p1.groupName}}"  class="example-list" >

              <div class="groupheading">
                <h2 *ngIf="p1.groupType ==1">
                  <mat-icon>create</mat-icon>{{p1.groupName}}
                </h2>

                <h2 *ngIf="p1.groupType !=1">
                  <mat-icon>description</mat-icon>{{p1.groupName}}
                </h2> 
                
              </div>

              <div *ngIf="p1.projGrpRelationParticipantList.length == 0" class="moveblock example-box">
                <p class="nocontent">No relationship added</p>
              </div>

              <div *ngFor="let p of p1.projGrpRelationParticipantList" class="moveblock example-box" >
                  
                <div class="Colrd" [ngStyle]="{'background-color': p.colourCode }">
                  <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
                </div>

                <div class="userInfo">
                  <div class="chipss">
                    <mat-chip-list>
                      <mat-chip> {{p.relationName}} </mat-chip>
                    </mat-chip-list>
                  </div>


                  <div class="selectContact" *ngIf="p.participantName || p.roleName || p.contactEmail">
                    <div class="userpic" *ngIf="p.participantImageURL">
                      <img [src]="p.participantImageURL" alt="" />
                    </div>

                    <div class="userpic" *ngIf="!p.participantImageURL">
                      <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                      <!-- <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span> -->
                      <span class="shortName" *ngIf="!p.participantName">{{getShortName(p.contactEmail)}}</span>
                    </div>

                    <div class="info">
                      <p *ngIf="p.participantName">{{ p.participantName }} </p>                     
                      <!-- <p *ngIf="p.roleName">{{ p.roleName }} </p> -->
                      <p *ngIf="!p.participantName">{{p.contactEmail}}</p>                     
                      <!-- <p class="emailID" *ngIf="p.participantEmail">{{ p.participantEmail }} </p> -->
                    </div>  

                    <button class="removeContact" mat-icon-button color="basic" (click)="RemoveRelation(p)">
                      <mat-icon>close</mat-icon>
                    </button>
                    
                    </div>
                  
                  <ng-container *ngIf="!p.participantName && !p.roleName &&  !p.contactEmail">
                    <button mat-icon-button color="primary" class="personadd"
                      (click)="assignUserNew(addAssigne,true,false,'',p,p1)">                   
                      <mat-icon>person_add</mat-icon>
                    </button>                   
                  </ng-container>

                </div>
                <div class="Cancel">                 
                </div>
              </div>
            </div>
          </div>           
        </div>
      </div>
      
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <span>
    <button mat-flat-button color="primary"  [disabled]="!SendButtonDisabled" (click)="ProjectSend()">Send</button>
    </span>
  </mat-dialog-actions>   
</ng-template>


<ng-template #addAssigne>    
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
     Add Participant
    <button mat-icon-button (click)="closeAssign()">  
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

      <mat-form-field *ngIf="typeOfParticipant==0 || typeOfParticipant==2">
        <mat-label>Type of Participant</mat-label>
        <mat-select (selectionChange)="onSelectParticpant($event)" [(ngModel)]="typeOfParticipant">
          <mat-select-trigger>
              {{ textNameShow }}
          </mat-select-trigger>
          <ng-container *ngFor="let participant of typeofParticipantList">
            <mat-option [value]="participant.value">
              <mat-icon *ngIf="participant.icon">{{ participant.icon }}</mat-icon>
              {{ participant.name }}
            </mat-option>
          </ng-container>         
          
        </mat-select>   
        </mat-form-field>

    <ng-container *ngIf="typeOfParticipant==2">
      <form class="example-form">      
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search contact</mat-label>         
          <input matInput maxlength="50" placeholder= "Type & Select"
          aria-label="State" [matAutocomplete]="auto" 
          (input)="searchUser($event.target.value)" id="stateCtrlid">
       <mat-autocomplete #auto="matAutocomplete">
       <mat-option (click)="contactSelected(contact)" *ngFor="let contact of contactsList" [value]="contact.name">
       <span class="userlist" style="display: flex;" fxLayout="row" fxLayoutAlign="flex-start center">
           <div class="userpic">
               <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
               <span class="username" *ngIf="contact.imageUrl==''" class="username">
                   {{contact.shortName}}
                 </span>
           </div>
           <div class="info1">
             <p> {{ contact.name }}</p>             
           </div> 
        </span>
      </mat-option>
      </mat-autocomplete>
       </mat-form-field>
      </form>
    </ng-container>

    <ng-container *ngIf="typeOfParticipant==0 || typeOfParticipant==1 || typeOfParticipant==3 || typeOfParticipant==4 || typeOfParticipant==5">
      <form class="example-form">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Add email</mat-label>         
          <input matInput maxlength="100" placeholder= "Add Email"
          [(value)]="emailAssigned" (input)="emailCheck($event.target.value)">
      
     </mat-form-field>
      </form>
    </ng-container>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeAssign()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateParticipants()">Done</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #userDetailCollect>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    <span>
      Provide Details
    </span>

    <button mat-icon-button (click)="closeEmailPopup()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content>
    <mat-form-field   class="example-full-width">
      <mat-label>Name for whom this form is being completed <span style="color:red"></span></mat-label>
      <input matInput required placeholder="Enter Name" [(ngModel)]="Name" />
    </mat-form-field>
    <mat-form-field  class="example-full-width">
      <mat-label>Email <span style="color:red"></span></mat-label>
      <input matInput placeholder="Enter email" required type="email" (input)="getEmailVerified()"
        [(ngModel)]="Email" />
    </mat-form-field>

    <mat-form-field  class="example-full-width">
      <mat-label>Mobile No. <span style="color:red"></span></mat-label>
      <input matInput maxlength="10" placeholder="Enter Mobile No." type="text"
        [(ngModel)]="Phone" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeEmailPopup()">Cancel</button>
    <button mat-flat-button class="calltoaction" [disabled]="ifSaveButtonDisabled()" type="submit"
      color="primary" (click)="IscreateProject(signature,userDetailCollect)">
      Start
    </button>
  </mat-dialog-actions>
</ng-template>

<app-loader></app-loader>
